import { render, staticRenderFns } from "./AssessmentExam.vue?vue&type=template&id=04fdcbfa&scoped=true"
import script from "./AssessmentExam.vue?vue&type=script&lang=js"
export * from "./AssessmentExam.vue?vue&type=script&lang=js"
import style0 from "./AssessmentExam.vue?vue&type=style&index=0&id=04fdcbfa&prod&scoped=true&lang=css"
import style1 from "./AssessmentExam.vue?vue&type=style&index=1&id=04fdcbfa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fdcbfa",
  null
  
)

export default component.exports